/* ============
 * Mutations for the account module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import types from './mutation-types';
import initialState from './state';

export default {
  [types.FETCH_PATIENT_PROGRESS_LIST](state) {
    state.isPatientProgressListloading = true;
  },
  [types.FETCH_PATIENT_PROGRESS_LIST_SUCCESS](state, response) {
    state.isPatientProgressListloading = false;
    state.totalCount = response.totalCount;
    state.patientProgressList = response.patientProgress;
  },
  [types.FETCH_PATIENT_PROGRESS_LIST_FAIL](state, error) {
    state.isPatientProgressListloading = false;
    state.error = error;
  },
  [types.FETCH_PATIENT_PROGRESS](state) {
    state.isPatientProgressloading = true;
  },
  [types.FETCH_PATIENT_PROGRESS_SUCCESS](state, response) {
    state.isPatientProgressloading = false;
    state.patientProgressDetails = response;
  },
  [types.FETCH_PATIENT_PROGRESS_FAIL](state, error) {
    state.isPatientProgressloading = false;
    state.error = error;
  },
  [types.RESET_PATIENT_PROGRESS](state) {
    state.patientProgressDetails = initialState.patientProgressDetails;
  },
  [types.FETCH_PATIENT_PROGRESS_BY_CYCLE](state) {
    state.loading = true;
  },
  [types.FETCH_PATIENT_PROGRESS_BY_CYCLE_SUCCESS](state, patientProgress) {
    state.loading = false;
    state.patientProgressDetails.patientProgress = patientProgress;
    state.patientProgressDetails = { ...state.patientProgressDetails };
  },
  [types.FETCH_PATIENT_PROGRESS_BY_CYCLE_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  }
};
